import { P2GBox, P2GButton, P2GGrid, P2GIcon, P2GLink, P2GText } from '@parcel2go/core-ui';
import { ApplierOption } from '~/apps/smartsend/lib/helpers/ApplierOption';
import { GetBulkActionIcon } from '../../smartsend/actions/GetBulkActionIcon';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';
import { GetBulkActionDescription } from '../../smartsend/actions/GetBulkActionDescription';
import { GetBulkActionActiveDescription } from '../../smartsend/actions/GetBulkActionActiveDescription';
import { GetBulkActionActiveButtonText } from '../../smartsend/actions/GetBulkActionActiveButtonText';

type props = {
  action: ApplierOption;
  isActive: boolean;
  onResetFilter: () => void;
  onActionClick: (action: ApplierOption) => void;
  onBulkFix: (action: ApplierOption) => void;
  buttonVariant?: 'primary' | 'secondary' | 'tertiary';
};

const BulkAction = ({ isActive, buttonVariant, onBulkFix, onActionClick, onResetFilter, action }: props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const isFix = action.includes(':Add');
  return (
    <P2GGrid container alignItems="center" gap={2} wrap="nowrap">
      <P2GGrid item>
        <P2GIcon size="sm">
          <P2GIcon size="sm">{GetBulkActionIcon(action)}</P2GIcon>
        </P2GIcon>
      </P2GGrid>
      <P2GGrid item flexGrow={1}>
        <P2GGrid container justifyContent="space-between" alignItems="center" spacing={1} wrap="nowrap">
          <P2GGrid item flexGrow={1}>
            <P2GText>
              <strong>
                {isActive ? GetBulkActionActiveDescription(t, action) : GetBulkActionDescription(t, action)}
              </strong>
            </P2GText>
          </P2GGrid>
          <P2GGrid item>
            <P2GBox display="flex" flexDirection="column" gap={1} alignItems="center">
              {!isActive ? (
                <P2GButton
                  onClick={() => onActionClick(action)}
                  variant={buttonVariant ?? (isFix ? 'primary' : 'tertiary')}
                  style={{ minWidth: 'unset', height: 'unset' }}
                >
                  {GetBulkActionActiveButtonText(t, action)}
                </P2GButton>
              ) : (
                <>
                  <P2GButton
                    onClick={() => onBulkFix(action)}
                    variant="secondary"
                    style={{ minWidth: 'unset', textWrap: 'nowrap' }}
                  >
                    {t('BULK_FIX_BUTTON', 'Bulk Fix')}
                  </P2GButton>
                  <P2GLink onClick={onResetFilter}>{t('CANCEL_LINK', 'Cancel')}</P2GLink>
                </>
              )}
            </P2GBox>
          </P2GGrid>
        </P2GGrid>
      </P2GGrid>
    </P2GGrid>
  );
};
export default BulkAction;
